import React from "react";
import { NavLink } from "react-router-dom";
import { DIR, t } from "../../i18n";
import { useAuthContext } from "../../contexts/AuthContext";
import { navItemsFor } from "./navItems";

// Desktop navigation: every page, always visible. Phones and tablets use the drawer in the navbar.
const Sidebar = () => {
  const { isOwner } = useAuthContext();

  return (
    <aside className="hidden w-60 shrink-0 lg:block xl:w-64 print:hidden">
      <nav
        dir={DIR}
        aria-label={t("التنقل الرئيسي")}
        className="card sticky top-6 space-y-1 p-2 max-h-[calc(100vh-3rem)] overflow-y-auto"
      >
        {navItemsFor(isOwner).map(({ path, label, Icon }) => (
          <NavLink
            key={path}
            to={path}
            className={({ isActive }) =>
              `flex items-center gap-3 rounded-xl px-4 py-3 font-medium transition-colors ${
                isActive
                  ? "bg-brand-600 text-white shadow-sm"
                  : "text-slate-700 hover:bg-brand-50 hover:text-brand-700"
              }`
            }
          >
            <Icon aria-hidden="true" className="shrink-0 text-xl" />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;
